import type { IconData } from '@stacksjs/iconify-core'

export const otherUiGraph2: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 0h-4v16h4zM6 4h4v12H6zM0 8h4v8H0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiGraph2
